
export * from '../../state/goals/selectors';



/** WEBPACK FOOTER **
 ** ./src/members/__shared__/selectors/goals.js
 **/